import { LocatieVoorEenheden } from '@/types/LocatieVoorEenheden';
import { QueryFunction, useQuery } from '@tanstack/react-query';

import useDefectLocatiesApi from './useDefectLocatiesApi';

const usePostDefectLocaties = (eenheden: string[], refreshInterval: number) => {
  const { getLocatiesVoorEenheden } = useDefectLocatiesApi();
  const fetcher: QueryFunction<LocatieVoorEenheden[]> = async () => getLocatiesVoorEenheden(eenheden);

  return useQuery({
    queryKey: ['locatieVoorEenheden', eenheden],
    queryFn: fetcher,
    refetchInterval: refreshInterval,
    enabled: eenheden.length > 0,
  });
};
export default usePostDefectLocaties;
